/**
 * Created by Marvin on 17.04.17.
 */
import React from 'react';
import { Link } from '@wikom/wikom-router';
import Conditional from '@wikom/react-conditional';
import { useRoute } from '@app/router';
import { isGuest } from '../helpers/menuHelpers';
var Footer = function () {
    var ROUTE = useRoute();
    return (React.createElement("footer", { className: "footer" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-4 col-md-push-8" },
                    React.createElement("div", { className: "footer-links" },
                        React.createElement("h3", { className: "footer-headline" }, "Links"),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("a", { href: "http://www.lwk-rlp.de/", target: "_blank", rel: "noopener noreferrer" }, "Landwirtschaftskammer Rheinland-Pfalz")),
                            React.createElement("li", null,
                                React.createElement(Conditional, { condition: function (_, _a) {
                                        var user = _a.user;
                                        return isGuest(user);
                                    } },
                                    React.createElement(Link, { to: ROUTE.PAGE.COMMON.CONTACT() }, "Kontakt")),
                                React.createElement(Conditional, { condition: function (_, _a) {
                                        var user = _a.user;
                                        return !isGuest(user);
                                    } },
                                    React.createElement(Link, { to: ROUTE.PAGE.COMMON.EMAIL_LWK() }, "Kontakt"))),
                            React.createElement("li", null,
                                React.createElement(Link, { to: ROUTE.PAGE.COMMON.ABOUT() }, "Impressum")),
                            React.createElement("li", null,
                                React.createElement(Link, { to: ROUTE.PAGE.COMMON.DATENSCHUTZ() }, "Datenschutzerkl\u00E4rung")),
                            React.createElement("li", null,
                                React.createElement(Link, { to: ROUTE.PAGE.COMMON.TERMS() }, "Nutzungsbedingungen"))))),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("div", { className: "footer-content" })),
                React.createElement("div", { className: "col-md-4 col-md-pull-8" },
                    React.createElement("div", { className: "footer-contact" },
                        React.createElement("h3", { className: "footer-headline" }, "Kontakt"),
                        React.createElement("p", null,
                            React.createElement("strong", null, "Landwirtschaftskammer Rheinland-Pfalz"),
                            React.createElement("br", null),
                            "Abteilung Weinbau",
                            React.createElement("br", null),
                            "Burgenlandstra\u00DFe 7",
                            React.createElement("br", null),
                            "55543 Bad Kreuznach"),
                        React.createElement("p", null, "Fax: 0671 / 793-7055"),
                        React.createElement("p", null,
                            "E-Mail: ",
                            React.createElement("a", { href: "mailto:wip@lwk-rlp.de" }, "wip@lwk-rlp.de")))),
                React.createElement("div", { className: "col-md-12" },
                    React.createElement("p", { className: "text-center" }, "\u00A9 Landwirtschaftskammer Rheinland-Pfalz"))))));
};
export default Footer;
